import logo_fd_wo_bg from './../assets/images/logo-fd-wo-bg.svg';

export const Footer = () => {

    return (
        <>
            <footer className="pt-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-6 col-xl-3 d-flex justify-content-center">
                            <img src={logo_fd_wo_bg} className="img-fluid" alt="Logo Stop Flavescence Dorée" />
                        </div>
                        <div className="col-12 menu-footer py-5">
                            <ul className="list-unstyled d-flex flex-wrap flex-column flex-lg-row justify-content-center text-center gap-1 gap-lg-0">
                                <li>
                                    <a className="text-decoration-none text-dark" href="/mentions-legales">Mentions légales</a>
                                </li>
                                <li>
                                    <a className="text-decoration-none text-dark" href="/politique-protection">Politique de protection des données personnelles</a>
                                </li>
                                <li>
                                    <a className="text-decoration-none text-dark" href="/contact">Contact</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}